<template>
    <div class="content">
        <Header :idx="'index'"/>

        <TopRecommends/>

        <div class="hotList">
            <div class="tit">
                <div>热门节目</div>
                <!--                <div><a>查看更多&gt;</a></div>-->
            </div>

            <ListVideoX :list="hotItemsList"/>
        </div>

        <div class="hotAct">
            <div class="left">
                <div class="tit">
                    热门推荐
                </div>

                <ListVCoverSummary :list="hotLists"/>
            </div>

            <div class="right">
                <div class="tit">
                    最新活动
                </div>

                <ListVCoverTitle :list="latestActivities"/>
            </div>
        </div>

        <Footer/>
    </div>
</template>
<script>
import Header from 'Components/header'
import Footer from 'Components/footer'
import TopRecommends from './top-recommend.vue'
import ListVCoverSummary from 'Components/news/list-v-cover-summary.vue'
import ListVCoverTitle from 'Components/news/list-v-cover-title.vue'
import ListVideoX from 'Components/news/list-video-x.vue'
import request from 'Services/axios'
import Utils from "@/utils/utils"

export default {
    data() {
        return {

            hotItemsList: [],
            hotLists: [],
            latestActivities: []

        }
    },
    created() {
        this.getData();

    },
    components: {
        Header,
        Footer,
        TopRecommends,
        ListVCoverSummary,
        ListVCoverTitle,
        ListVideoX
    },
    methods: {
        tplGetDetailLink(id) {
            return Utils.getPageUrl('detail', {id})
        },

        getData() {
            this.getHotItems();
            this.getLatestActivities();
            this.gethotList();
        },

        //热门节目
        getHotItems() {
            request({url: '/api/web/article/hotItems.htm'}).then((res) => {
                let oriData = res.data;

                this.hotItemsList = (oriData.data.itemList || oriData.data || []).slice(0, 4);

                console.log('hotItemsList数据=======', this.hotItemsList);

            }).catch(error => {
                console.log('hotItems error', error)
            })
        },

        //最新活动
        getLatestActivities() {
            request({url: '/api/web/article/latestActivities.htm'}).then((res) => {
                let oriData = res.data;

                this.latestActivities = (oriData.data.itemList || oriData.data || []).slice(0, 6);

                console.log('latestActivities数据=======', this.latestActivities);

            }).catch(error => {
                console.log('latestActivities error', error)
            })
        },

        //左下角热门推荐
        gethotList() {
            request({
                url: '/api/web/article/list.htm?type=1&pageSize=10',
                method: 'get',
            }).then((res) => {
                let oriData = res.data;

                this.hotLists = (oriData.data.itemList || []);

                console.log('hotList数据=======', this.hotLists);

            }).catch(error => {
                console.log('hotList error', error)
            })
        },

    }
};
</script>
<style lang="less">
.content {
    width: 1196px;
    margin: 0 auto;


    .ad {
        height: 88px;
        background: gray;
        margin-bottom: 32px;
    }

    .hotList {
        height: 270px;
        margin-bottom: 32px;

        .tit {
            height: 57px;
            overflow: hidden;
            padding-top: 8px;
            display: flex;
            justify-content: space-between;

            div {
                font-size: 24px;
            }

            a {
                font-size: 16px;
                cursor: pointer;
            }

            a:hover {
                background: #dedede;
            }
        }
    }

    .hotAct {
        width: 1196px;
        display: flex;
        justify-content: space-between;
        position: relative;

        .left {
            width: 800px;
        }

        .right {
            width: 395px;
            padding-left: 25px;
            top: 10px;

            /*background: #888;*/

            .tit {
                margin-bottom: 16px;
            }


        }

        .tit {
            height: 57px;
            overflow: hidden;
            padding-top: 8px;
            font-size: 24px;
        }
    }


}
</style>
